import { useEffect, useReducer } from 'react'

import { AuthContextData, AuthContextDataStoreEvent } from '@surglogs-app/types'

import { useAuthContext } from './useAuthContext'

interface IState<TData> {
  data: TData | null
  loading: boolean
}
type IAction<TData> =
  | { type: 'set_data'; data: TData | null }
  | { type: 'set_loading'; loading: boolean }

const reducer = <TData>(
  state: IState<TData>,
  action: IAction<TData>,
): IState<TData> => {
  switch (action.type) {
    case 'set_data':
      return { data: action.data, loading: false }
    case 'set_loading':
      return { data: state.data, loading: action.loading }
    default:
      return state
  }
}

export const useAuthContextExtended = <TData extends AuthContextData>() => {
  const { contextDataStore } = useAuthContext()
  // TODO: lazy init of initial state
  const [state, dispatch] = useReducer(reducer, {
    data: contextDataStore.getData() as TData,
    loading: contextDataStore.isDataFetching(),
  })

  useEffect(() => {
    const onStart = () => dispatch({ type: 'set_loading', loading: true })
    const onEnd = (data: any) => dispatch({ type: 'set_data', data })
    contextDataStore.on(AuthContextDataStoreEvent.UPDATING, onStart)
    contextDataStore.on(AuthContextDataStoreEvent.UPDATED, onEnd)
    return () => {
      contextDataStore.off(AuthContextDataStoreEvent.UPDATING, onStart)
      contextDataStore.off(AuthContextDataStoreEvent.UPDATED, onEnd)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return state
}
